import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    GET_ADMIN_URL,
    GET_ADMIN_BUSINESS_OVERVIEW_URL,
    GET_BLOGS_URL,
    GET_BUSINESS_URL, GET_EMAIL_SENT_URL, GET_TOPUP_ACTIVITY_BUSINESS_URL,
    GET_TOPUP_BUSINESS_URL,
    GET_USERS_ADMIN_URL
} from "../../api/urls";
import api from "../../api/axios";


export const getAdminUsers = createAsyncThunk("users/admin", async (data, { rejectWithValue }) => {
  try {
    const response = await api.get(GET_USERS_ADMIN_URL, {
      params: {
        pageSize: data.pageSize,
        currentPage: data.currentPage,
        sort: data.sort,
        search: data?.search,
        businessId: data?.businessId,
      },
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message || "Error fetching data");
  }
});

export const getAdminEmailRecipients = createAsyncThunk(
  "adminEmails/recipients",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_USERS_ADMIN_URL, {
        params: {
          pageSize: data.pageSize || 100,
          currentPage: data.currentPage || 1,
          search: data.search,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || error.message || "Error fetching email recipients"
      );
    }
  }
);

export const getAdminDashboard = createAsyncThunk("admin", async (data, { rejectWithValue }) => {
  try {
    const response = await api.get(`${GET_ADMIN_URL}`, {
      params: data,
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message || "Error fetching data");
  }
});

export const getAdminBusinessOverview = createAsyncThunk(
  "admin/businessOverview",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_ADMIN_BUSINESS_OVERVIEW_URL, {
        params: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || error.message || "Error fetching businesses"
      );
    }
  }
);

export const getAdminBusinessUsers = createAsyncThunk(
  "admin/businessUsers",
  async ({ businessId, ...params }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `${GET_ADMIN_BUSINESS_OVERVIEW_URL}/${businessId}/users`,
        { params }
      );
      return Array.isArray(response.data)
        ? { users: response.data, businessId }
        : { ...response.data, businessId };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || error.message || "Error fetching business users"
      );
    }
  }
);

export const getSentEmails = createAsyncThunk("adminEmails", async (data, { rejectWithValue }) => {
    try {
        const response = await api.get(`${GET_EMAIL_SENT_URL}`, {
            params: data,
        });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.message || "Error fetching data");
    }
});

export const getBusinessDashboard =
    createAsyncThunk("business", async (data, { rejectWithValue }) => {
  try {
    const response = await api.get(`${GET_BUSINESS_URL}`, {
      params: data,
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.message || "Error fetching data");
  }
});

export const getTopUpIndex =
    createAsyncThunk("businessTopup",
        async (data, { rejectWithValue}) => {
      try {
        const response = await api.get(`${GET_TOPUP_BUSINESS_URL}`,
            {
          params: data,
        });
        return response.data;
      } catch (error) {
        return rejectWithValue(error.message || "Error fetching data");
      }
    });

export const getTopUpActivity =
    createAsyncThunk("businessTopupActivity",
        async (data, { rejectWithValue}) => {
          try {
            const response = await api.get(`${GET_TOPUP_ACTIVITY_BUSINESS_URL}`,
                {
                  params: data,
                });
            return response.data;
          } catch (error) {
            return rejectWithValue(error.message || "Error fetching data");
          }
        });
export const getBlogItems =
    createAsyncThunk("fetchBlogItems",
        async (data, {rejectWithValue}) => {
            try {
                const response = await api.get(`${GET_BLOGS_URL}`,
                    {
                        params: data,
                    });
                return response.data;
            } catch (error) {
                return rejectWithValue(error.message || "Error fetching data");
            }
        });
